import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderVideoModule } from 'render/render-shared/ui/render-video/render-video.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceVideoRenderComponent } from './piece-video-render.component';


export const pieceVideoRenderModuleEntryComponents = [
  PieceVideoRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    LazyLoadModule,
    RenderVideoModule,
  ],
  declarations: pieceVideoRenderModuleEntryComponents,
  exports: [
    PieceVideoRenderComponent
  ]
})
export class PieceVideoRenderModule {}

export default pieceVideoRenderModuleEntryComponents;
